<template>
	<div>
		<ihead :checkindex="checkindex"></ihead>
		<div class="banner-box">			
			<h1>大事记</h1>
		</div>
        <crumbs :items='items'></crumbs>
         <div class="warp">
             <h1>这里是个标题</h1>
             <div class="timer-reading clearfix">
                 <div class="timer-reading-left">
                     <i class="iconfont icon-linedesign-14"></i>
                     <span>500</span>
                 </div>
                 <div class="timer-reading-right">
                     <span>2017-05-04</span>
                 </div>
            </div>   
            <imgtext :detailList='detailList'></imgtext>	 
         </div>
		<ifoot></ifoot>
		<returntop class="return-top"></returntop>
	</div>
</template>

<script>
import ihead from "@/components/ihead.vue"
import ifoot from '@/components/ifoot.vue'
import crumbs from "@/components/crumbs.vue"
import returntop from '@/components/returntop'
import imgtext from '@/components/article_detail'
export default {
components: {
		ihead,ifoot,crumbs,returntop,imgtext
},
data (){
	return {
		checkindex:1,
		items:[
                {
                text: '首页',
                disabled: false
                },
                {
                text: '机构设置',
                disabled: false
                },
                {
                text: '大事记',
                disabled: true
                }
            ],
            detailList:[{
                key:1,                			
                dataImg:'http://aqlshg.qiaochang.com/institute/images/resource/pic-2.jpg',
                dataContent:' 湖北省十堰市郧西县涧池乡下营村，依山傍水，风景秀丽，这里是天地传说中牛郎织女故事中的牛郎故乡，也是绿松石的主产地之一。从2012到2014，下营村发生了巨大的变化，开网店的人数呈几何倍数增长。从最初的几人到70多家，快递公司纷纷入驻下营村。2014年年底，下营村被阿里巴巴授予“中国淘宝村”的荣誉称号，也是湖北省唯一的一个淘宝村。2015年，全村网店已有一百多家，从事绿松石工作的就有500多人，年轻人纷纷返乡开网店卖绿松石。如今，下营村毕业大学生、退伍军人、留守妇女、残疾人等社会群体纷纷加入到农村电商的行业中，带动全乡7000多人创业就业，年产值过亿。十堰市因此掀起了一场“互联网+绿松石”的创业热潮，彻底改变了绿松石产品的销售模式，推动了十堰市绿松石产业的转型升级。下营村通过农村电商实现自助脱贫，基本实现就业本地化、产品在线化、消费都市化。',
                dataRead:2222
            }]	            					   
		}
	},
	methods: {		
	},
}
</script>

<style>
.timer-reading{
    width: 20%;
    margin: 20px auto;
}
.timer-reading-left{
    float: left;
}
.timer-reading-right{
   float: right;
}
.icon-linedesign-14 {
    font-size: 14px !important;
    margin-right: 5px;
}
</style>
